import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';
import { SometimesInlineRadioWrapper } from './Filters.styles';
import { updateFilter, furnishingsSelector } from '../../reducers/filters';

export const SelectFurnishings: FC = () => {
    const reduxDispatch = useDispatch();

    const { selectedValue, options } = useSelector(furnishingsSelector);

    const onFurnishingsChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('furnishedState', evt.currentTarget.value));
    };
    const current = selectedValue === '' ? 'Any' : selectedValue;

    return (
        <>
            {options?.map((option) => {
                return (
                    <SometimesInlineRadioWrapper key={option.value}>
                        <Radio
                            label={option.label}
                            value={option.value}
                            id={option.value.replace(' ', '-').toLowerCase()}
                            data-testid={option.value}
                            onChange={onFurnishingsChange}
                            checked={option.value === current}
                        />
                    </SometimesInlineRadioWrapper>
                );
            })}
        </>
    );
};
